import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-teacher-game-setup-overlay-header',
  templateUrl: './teacher-game-setup-overlay-header.component.html',
  styleUrls: ['./teacher-game-setup-overlay-header.component.scss']
})
export class TeacherGameSetupOverlayHeaderComponent implements Overlayable {
  @Output() onClosed = new EventEmitter<boolean>();

  @Input('totalSteps') totalSteps = 99;
  @Input('step') set setStep(val: number) {
    switch (val) {
      case 1:
        this.label = "Welche Kategorie möchtest du spielen?";
        break;
      case 2:
        this.label = "Spielzeit wählen";
        break;
    }

    this.currentStep = val;
  }

  currentStep = 0;
  label = "";
}
